import { render, staticRenderFns } from "./FilterColorCheckboxes.vue?vue&type=template&id=2664c0c7&scoped=true&"
import script from "./FilterColorCheckboxes.vue?vue&type=script&lang=js&"
export * from "./FilterColorCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./FilterColorCheckboxes.vue?vue&type=style&index=0&id=2664c0c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664c0c7",
  null
  
)

export default component.exports